<template>
  <v-container>
    <v-tabs
      v-model="tab"
      class="mb-4"
    >
      <v-tab>
        <v-icon
          left
          small
        >
          mdi-account-search
        </v-icon>
        ປະຫວັດລູກຄ້າ
      </v-tab>
      <v-tab>
        <v-icon
          left
          small
        >
          mdi-format-list-bulleted
        </v-icon>
        ທັງໝົດ (ຕາມພະນັກງານ / ວັນທີ)
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <CustomerHistory />
      </v-tab-item>
      <v-tab-item>
        <ActivityLogAll />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import CustomerHistory from './activity/CustomerHistory.vue';
import ActivityLogAll from './ActivityLogAll.vue';

export default {
  name: 'ActivityLog',
  components: { CustomerHistory, ActivityLogAll },
  title() {
    return 'Vientiane Waste Co-Dev|Activity Log';
  },
  data() {
    return { tab: 0 };
  },
};
</script>
